import React from 'react';

import { useActions, useAppState } from '@/overmind';
import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import { useFindFeaturesOnMapClick } from '../../hooks/useFindFeaturesOnMapClick';
import type { FeaturesInBounds } from './FeaturePicker/FeaturePicker';
import { FeaturePicker } from './FeaturePicker/FeaturePicker';
import { useAutoFetchNewGridImages } from './useAutoFetchNewGridImages';
import { useGridImageWithTransition } from './useGridImageWithTransition';

export function useFeaturesToPickFrom(): FeaturesInBounds {
  const featuresInBoundsState = useAppState().arcgis.featuresInBounds;

  return featuresInBoundsState.current === 'LOADED'
    ? featuresInBoundsState.value
    : {
        features: []
      };
}

export function PickFeaturesFromGridImage() {
  const { setSelectedFeature } = useActions().selectedFeature;
  const featuresToPickFrom = useFeaturesToPickFrom();

  const [unloadFoundFeatures] = useFindFeaturesOnMapClick();

  const selectFeature = (selected: FeatureWithIDs) => {
    unloadFoundFeatures();
    setSelectedFeature({ ...selected });
  };

  return (
    <FeaturePicker
      featuresToPickFrom={featuresToPickFrom}
      onSelected={selectFeature}
      onClose={unloadFoundFeatures}
    />
  );
}

export function GridImageLayer() {
  useGridImageWithTransition();
  useAutoFetchNewGridImages();

  return <PickFeaturesFromGridImage />;
}
